import { GET_INSTALLER_API } from '~/constants/APIs'
import axiosClient from './axiosClient'
import { IClientInstaller } from '~/models'

export const clientInstallerApis = {
  getInstaller: () => axiosClient.get(GET_INSTALLER_API) as unknown as IClientInstaller,
  downLoadSetup: (url: string) => axiosClient.get(url, { responseType: 'blob' })
}
